const initializeHomeStories = function(scope = document) {
    const cards = scope.querySelectorAll('.home-stories__card--video:not([data-video-initialized])');

    cards.forEach(function(card) {
        const video = card.querySelector('video');
        const playButton = card.querySelector('.home-stories__play');

        if (!video || !playButton) {
            return;
        }

        playButton.addEventListener('click', function() {
            video.controls = true;
            video.play();
            card.classList.add('is-playing');
        });

        video.addEventListener('ended', function() {
            video.controls = false;
            card.classList.remove('is-playing');
            video.load();
        });

        card.dataset.videoInitialized = 'true';
    });
};

document.addEventListener('DOMContentLoaded', function() {
    initializeHomeStories();
});

if (window.acf) {
    window.acf.addAction('render_block_preview/type=home-stories', function(block) {
        initializeHomeStories(block[0] || block);
    });
}
